import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { dateTimeFormat } from "../../../util/DateUtil";
import Loading from "../../UI/Loading";
import EventoStatusChip from "./EventoStatusChip";

export default function EventoTable({ eventos, isLoading, onChangePage, onSelect }) {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando eventos..." />
      </Box>
    );
  }

  if (eventos.content.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <EventOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum evento cadastrado.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" sx={{ minWidth: 800 }} aria-label="Lista de eventos">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
              <TableCell>Título</TableCell>
              <TableCell>Período</TableCell>
              <TableCell>Destinatários</TableCell>
              <TableCell>Criado por</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {eventos.content.map((evento) => (
              <TableRow key={evento.codigo} hover onClick={() => onSelect(evento)} sx={{ cursor: "pointer" }}>
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>
                    {evento.titulo}
                  </Typography>
                  {evento.lastModified && (
                    <Typography variant="caption" color="text.secondary">
                      Atualizado em {dateTimeFormat(evento.lastModified)}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{dateTimeFormat(evento.dataHoraInicio)}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    até {dateTimeFormat(evento.dataHoraFim)}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{evento.enviarPara}</Typography>
                  {evento.enviarPor && (
                    <Typography variant="caption" color="text.secondary">
                      por {evento.enviarPor}
                    </Typography>
                  )}
                </TableCell>
                <TableCell>{evento.usuario?.nome ?? ""}</TableCell>
                <TableCell>
                  <EventoStatusChip evento={evento} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={eventos.size || 0}
        component="div"
        count={eventos.totalElements || 0}
        page={eventos.number || 0}
        onPageChange={onChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </Box>
  );
}
